import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import {
  getFirstAccessiblePath,
  hasPageAccess,
  isServiceCatalogPath,
  isSuperUser,
} from "./pageAccess";

export const PrivateRoute = ({ children, pageKey }) => {
  const { isLogged, user } = useSelector((state) => state.user);
  const location = useLocation();

  if (!isLogged) {
    const isSuperPath = isServiceCatalogPath(location.pathname);
    return <Navigate to={isSuperPath ? "/superuser" : "/"} />;
  }

  if (
    isSuperUser(user) &&
    !isServiceCatalogPath(location.pathname) &&
    location.pathname !== "/profile"
  ) {
    return <Navigate to="/service-catalog" replace />;
  }

  if (!isSuperUser(user) && isServiceCatalogPath(location.pathname)) {
    return <Navigate to="/portfolio-dashboard" replace />;
  }

  if (pageKey && !hasPageAccess(user, pageKey)) {
    return <Navigate to={getFirstAccessiblePath(user)} replace />;
  }

  //   if (isAuthenticated) {
  //     if (isAdmin === true && user.role !== "admin") {
  //       return <Navigate to="/" />;
  //     }
  //     return children;
  //   }

  return children;
};

export const PublicRoute = ({ children }) => {
  const { isLogged, user } = useSelector((state) => state.user);

  if (isLogged) {
    return <Navigate to={getFirstAccessiblePath(user)} replace />;
  }

  return children;
};
